import { render, staticRenderFns } from "./card-form.vue?vue&type=template&id=71ef6d0a&scoped=true&"
import script from "./card-form.vue?vue&type=script&lang=js&"
export * from "./card-form.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap4.css?vue&type=style&index=0&id=71ef6d0a&scoped=true&lang=css&"
import style1 from "@/assets/sass/home.css?vue&type=style&index=1&id=71ef6d0a&scoped=true&lang=css&"
import style2 from "./register.scss?vue&type=style&index=2&id=71ef6d0a&scoped=true&lang=scss&"
import style3 from "./card-form.vue?vue&type=style&index=3&id=71ef6d0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef6d0a",
  null
  
)

export default component.exports